<template>
    <div class='main'>
        <div class='title-wrapper'>
            <h4 class='subtitle'>カート一覧</h4>
            <i class="fas fa-shopping-cart cart"></i>
            <button class="button is-danger cart-all-delete" @click='cartAllDelete()'>カートを空にする</button>
        </div>
        <div v-if='photos && photos.length'>
            <p class='has-text-danger'>※他学校等、一度に決済できない場合があります</p>
            <div v-for='events in eventsGroupedByPhotographer' :key='events[0].event.id' class='photographer-wrapper'>
                <div v-for='val in events' :key='val.event.id' class='event-wrapper'>
                    <h4 class='title-1'>{{ `${val.event.school.name} - ${val.event.name}` }}</h4>
                    <div class='photos'>
                        <div v-for='photo in val.photos' :key='photo.id' class='photo-wrapper'>
                            <div class='photo'>
                                <img v-if='photo.reduction_s3_key' :src='`${photoBaseUrl}/${photo.reduction_s3_key}`' @click='detail(photo)'>
                                <img v-else :src='`${photoBaseUrl}/${photo.s3_key}`' @click='detail(photo)'>
                                <p class='photo-name' :title='photo.name'>{{ photo.name }}</p>
                                <div class='image-bottom'>
                                    <div class='cart-btn' @click='cartIn(photo.id)' :class='{ "cart-btn-active": cartMap[photo.id] }'>
                                        <i class="fas fa-shopping-cart"></i>
                                    </div>
                                    <select class='select-size' v-model='photo.size' @change='changePhoto(photo.id, photo.size, photo.length)'>
                                        <option v-if='!isAvailableSize(getEventSizes(val.event), photo.size)' :value='photo.size' disabled>サイズを選び直してください</option>
                                        <option v-for='(size, i) in getEventSizes(val.event)' :key='i' :value='size.name'>
                                            {{ size.name }}
                                        </option>
                                    </select>
                                    <select class='select-length' v-model='photo.length' @change='changePhoto(photo.id, photo.size, photo.length)'>
                                        <option v-for='n in 99' :key='n' :value='n' class='length'>
                                            {{ n }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button class='button is-primary is-fullwidth is-medium next' @click='next(events[0].event.user_id)'>確認して次へ</button>
            </div>
        </div>
        <div v-else>
            <p>カートに入っている写真はありません</p>
        </div>
        <div class="modal detail-modal" :class=' { "is-active": modalActive }'>
            <div class="modal-background" @click='modalClose'></div>
            <div class="modal-card">
                <div class='image-wrapper'>
                    <img v-if='detailPhoto.reduction_s3_key' class='view-img' :src='`${photoBaseUrl}/${detailPhoto.reduction_s3_key}`' alt="">
                    <img v-else class='view-img' :src='`${photoBaseUrl}/${detailPhoto.s3_key}`' alt="">
                </div>
                <button class="modal-close-btn" aria-label="close" @click='modalClose'>
                    <i class="fas fa-times"></i>
                </button>
                <footer class="modal-card-foot">
                    <p class='modal-photo-name'>{{ detailPhoto.name }}</p>
                    <div class="modal-cart-btn" @click='cartIn("detail")' :class='{ "modal-cart-btn-active": cartMap[detailId] }'>
                        <i class="fas fa-shopping-cart"></i>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import { isAvailableSize } from '@/helpers/printSize'

export default {
    name: 'Cart',
    props: ['cartMap', 'cart'],
    components: {
    },
    data () {
        return {
            photoBaseUrl: process.env.PHOTO_BASE_URL,
            detailId: null,
            detailPhoto: {},
            modalActive: false,
            eventsGroupedByPhotographer: [],
            photos: []
        }
    },
    mounted () {
        this.displayPhoto()
    },
    watch: {
        cart: {
            deep: true,
            handler () {
                this.displayPhoto()
            }
        }
    },
    methods: {
        isAvailableSize,
        cartIn (id) {
            if (id === 'detail') {
                this.$root.$emit('cartIn', { id: this.detailId, size: undefined })
            } else {
                this.$root.$emit('cartIn', { id: id, size: undefined })
            }
        },
        detail (photo) {
            this.detailId = photo.id
            this.detailPhoto = photo
            this.modalActive = true
        },
        changePhoto (id, size, length) {
            this.$root.$emit('changePhoto', { id: id, size: size, length: length })
        },
        getEventSizes (event) {
            if (!event || !event.setting) return []
            const setting = typeof event.setting === 'string' ? JSON.parse(event.setting) : event.setting
            if (!setting.sizes) return []
            return setting.sizes.filter(s => s.use)
        },
        displayPhoto () {
            const self = this

            let photoIds = []

            self.photos = self.cart
            const cartMapById = {}
            for (const photo of self.cart) {
                cartMapById[photo.id] = photo
            }

            for (const photo of self.cart) {
                photoIds.push(photo.id)
            }

            self.axios.post(`${process.env.API_URL}/photobuy/cart`, {
                photoIds
            }).then((res) => {
                if (res.data.message === 'unauthenticated') {
                    self.$router.push('/login')
                    return
                }

                const grouped = res.data.eventsGroupedByPhotographer
                for (const key in grouped) {
                    const events = grouped[key]
                    for (const val of events) {
                        for (const photo of val.photos) {
                            if (cartMapById[photo.id]) {
                                if (cartMapById[photo.id].length) {
                                    photo.length = cartMapById[photo.id].length
                                }
                                if (cartMapById[photo.id].size) {
                                    photo.size = cartMapById[photo.id].size
                                }
                            }
                        }
                    }
                }
                self.eventsGroupedByPhotographer = grouped
            }).catch((e) => {
                alert('サーバーに問題が発生しています')
            })
        },
        modalClose () {
            this.modalActive = false
        },
        next (photographerId) {
            const groups = this.eventsGroupedByPhotographer[photographerId] || []
            if (groups.some(group => group.photos.some(photo => !isAvailableSize(this.getEventSizes(group.event), photo.size)))) {
                this.$root.$emit('notification', 'is-warning', '販売サイズが変更された写真があります。サイズを選び直してください')
                return
            }
            this.$router.push(`/photobuy/order?pgi=${photographerId}`)
        },
        cartAllDelete () {
            if (window.confirm('カートを空にしますか？')) {
                this.$root.$emit('cartClear')
                this.photos = []
                this.eventsGroupedByPhotographer = {}
                this.$root.$emit('notification', 'is-primary', 'カートを空にしました')
            }
        }
    }
}
</script>

<style scoped>

.main {
    max-width: 1280px;
    min-height: calc(100vh - 80px);
    margin: auto;
    padding: 20px;
    overflow-x: hidden;
}

.next {
    margin-top: 50px;
}

.subtitle {
    font-weight: bold;
    margin: 0;
    line-height: 1.2;
}

.title-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
}

.cart {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-left: 0;
    height: 24px;
    width: 24px;
    font-size: 22px;
    line-height: 1;
}

.photos {
    margin-top: 20px;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-auto-flow: row;
    gap: 4px;
    overflow: hidden;
}

.photo-wrapper {
    display: block;
    width: 100%;
    align-self: start;
}

.photo {
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 3px;
    background: #fff;
    overflow: hidden;
}

.photo > img {
    cursor: pointer;
    width: 100%;
    display: block;
}

.photo-name {
    margin: 0;
    padding: 6px 7px 2px;
    overflow: hidden;
    color: #333;
    font-size: 12px;
    line-height: 1.25;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.image-bottom {
    display: flex;
    height: 40px;
    align-items: center;
    padding: 0 4px;
    gap: 4px;
}

.cart-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    background: #e8e8e8;
    color: #555;
    cursor: pointer;
    font-size: 14px;
    flex-shrink: 0;
    transition: background 0.2s, color 0.2s;
}

.cart-btn-active {
    background: #3cb371;
    color: #fff;
}

.bottom-icon {
    margin-left: 4px;
    margin-right: 4px;
    height: 36px;
    width: 26px !important;
    cursor: pointer;
}

.select-size {
    flex: 1;
    min-width: 0;
    height: 30px;
    font-size: 14px;
    margin-top: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: 0 6px;
    border: 1px solid #ccc;
    border-radius: 3px;
    background: #fff;
}

.select-length {
    width: 50px;
    height: 30px;
    font-size: 14px;
    margin-top: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: 0 6px;
    border: 1px solid #ccc;
    border-radius: 3px;
    background: #fff;
}

.event-wrapper {
    margin-top: 40px;
}

.cart-all-delete {
    margin-left: 20px;
    height: 30px;
    width: 180px;
}

/* Modal */
.detail-modal {
    z-index: 200;
}

.modal-card {
    background-color: rgb(220, 220, 220);
    border-radius: 6px;
    overflow: scroll;
    max-height: 100vh;
    max-width: 95vw;
    position: relative;
}

.image-wrapper {
    position: relative;
    display: block;
    width: 100%;
}

.view-img {
    width: 100%;
    max-height: calc(100vh - 80px);
    object-fit: contain;
    display: block;
}

.modal-close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;
    width: 40px;
    height: 40px;
    border: none;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
}

.modal-close-btn:hover {
    background: rgba(0, 0, 0, 0.7);
}

.modal-card-foot {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 12px 16px;
    background: rgba(0, 0, 0, 0.6);
    border-top: none;
}

.modal-photo-name {
    min-width: 0;
    margin: 0;
    overflow-wrap: anywhere;
    color: #fff;
    font-size: 13px;
}

.modal-cart-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    transition: background 0.2s;
}

.modal-cart-btn:hover {
    background: rgba(255, 255, 255, 0.3);
}

.modal-cart-btn-active {
    background: #3cb371 !important;
    color: #fff !important;
}

@media screen and (max-width: 1100px) {
    .photos {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 600px) {
    .main {
        padding: 10px;
    }

    .title-wrapper {
        flex-wrap: wrap;
        gap: 8px 10px;
    }

    .cart {
        height: 22px;
        width: 22px;
        font-size: 20px;
    }

    .cart-all-delete {
        margin-left: 0;
        width: 160px;
        height: 32px;
    }

    .photos {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 2px;
    }

    .photo {
        border-radius: 2px;
    }

    .search {
        display: none;
    }

    .image-bottom {
        height: 32px;
        padding: 0 2px;
        gap: 2px;
    }

    .cart-btn {
        width: 28px;
        height: 28px;
        font-size: 12px;
    }

    .select-size {
        height: 26px;
        font-size: 12px;
        padding: 0 4px;
    }

    .select-length {
        width: 36px;
        height: 26px;
        font-size: 12px;
        padding: 0 4px;
    }

    .modal-card-foot {
        padding: 10px;
    }

    .modal-cart-btn {
        width: 42px;
        height: 42px;
        font-size: 18px;
    }

    .modal-close-btn {
        width: 44px;
        height: 44px;
        font-size: 22px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/photobuy/pages/Cart.vue